
import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import taxDetail from './views/taxDetail.vue';//home公共列表详情页面
import OfflineDetail from './views/OfflineDetail.vue';//培训服务---线下培训详情
import tsDetail from './views/tsDetail.vue';//培训服务---专题课堂详情页
import tscsDetail from './views/tscsDetail.vue';//培训服务---推荐详情页
import bbsDetail from './views/bbsDetail.vue';//培训服务---财税社区---回答
import InvitaCode from './views/InvitaCode.vue';//培训服务---财税社区---回答
import lcDetail from './views/lcDetail.vue';//直播课程详情
import LiveBack from './views/LiveBack.vue';//直播课程详情回放播放
import sfDetail from './views/sfDetail.vue';//涉税---金融服务
import qbDetail from './views/qbDetail.vue';//涉税---答疑库
import spDetail from './views/spDetail.vue';//涉税---专业服务
import tqDetial from './views/tqDetial.vue';//涉税---税率查询
import psDetail from './views/psDetail.vue';//涉税---流程自助
import CalculationResult from "./views/CalculationResult.vue"; // 个税计算结果
import BusineEgistrat from "./views/BusineEgistrat.vue"; //企业注销
import AgentBookKeep from "./views/AgentBookKeep.vue"; //代理记账
import EnterCancellat from "./views/EnterCancellat.vue"; //企业注销
import TestPaper from "./views/TestPaper.vue"; //企业服务---测评
import TaxPlan from "./views/TaxPlan.vue"; //税务筹划
import TaxConsultat from "./views/TaxConsultat.vue"; //税务咨询
import hnDetail from "./views/hnDetail.vue"; //海南自贸详情
import cspx from "./views/cspx.vue"; //海南自贸详情--财税培训
import dljz from "./views/dljz.vue"; //海南自贸详情--代理记账
import gczx from "./views/gczx.vue"; //海南自贸详情--工程咨询
import qyzc from "./views/qyzc.vue"; //海南自贸详情--企业注册
import sjfw from "./views/sjfw.vue"; //海南自贸详情--审计服务
import swch from "./views/swch.vue"; //海南自贸详情--税务筹划
import swfw from "./views/swfw.vue"; //海南自贸详情--商务服务
import swzx from "./views/swzx.vue"; //海南自贸详情--税务咨询
import tzzx from "./views/tzzx.vue"; //海南自贸详情--投资咨询
import goodsDetail from "./views/GoodsDetail.vue"; //商品详情
Vue.use(Router);
export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        style: true
      }
    },
    //详情页
    {
      path: "/taxDetail",
      name: "taxDetail",
      component: taxDetail,
      meta: {
        style: false
      }
    },
    // 培训 -- 线下培训---详情
    {
      path: "/OfflineDetail",
      name: "OfflineDetail",
      component: OfflineDetail,
      meta: {
        style: true
      }
    },
    //培训---专题课堂详情页
    {
      path: "/tsDetail",
      name: "tsDetail",
      component: tsDetail,
      meta: {
        style: false
      }
    },
    //培训---推荐详情页
    {
      path: "/tscsDetail",
      name: "tscsDetail",
      component: tscsDetail,
      meta: {
        style: true
      }
    },
    //直播课程---详情
    {
      path: "/lcDetail",
      name: "lcDetail",
      component: lcDetail,
      meta: {
        style: true
      }
    },
    //回放
    {
      path: "/LiveBack",
      name: "LiveBack",
      component: LiveBack,
      meta: {
        style: true
      }
    },
    // 回复列表
    {
      path: "/bbsDetail",
      name: "bbsDetail",
      component: bbsDetail,
      meta: {
        style: false
      }
    },
    // 邀请码
    {
      path: "/InvitaCode",
      name: "InvitaCode",
      component: InvitaCode,
      meta: {
        style: false
      }
    },
    // 金融服务
    {
      path: "/sfDetail",
      name: "sfDetail",
      component: sfDetail,
      meta: {
        style: false
      }
    },
    //专业服务
    {
      path: "/spDetail",
      name: "spDetail",
      component: spDetail,
      meta: {
        style: true
      }
    },
    // 答疑库
    {
      path: "/qbDetail",
      name: "qbDetail",
      component: qbDetail,
      meta: {
        style: false
      }
    },
    //tqDetial税率查询
    {
      path: "/tqDetial",
      name: "tqDetial",
      component: tqDetial,
      meta: {
        style: false
      }
    },
    //流程自助
    {
      path: "/psDetail",
      name: "psDetail",
      component: psDetail,
      meta: {
        style: false
      }
    },
    // 个税计算结果
    {
      path: "/CalculationResult",
      name: "CalculationResult",
      component: CalculationResult,
      meta: {
        style: false
      }
    },
    //TODO 企业注册
    {
      path: "/BusineEgistrat",
      name: "BusineEgistrat",
      component: BusineEgistrat,
      meta: {
        style: false
      }
    },
    //测评
    {
      path: "/TestPaper",
      name: "TestPaper",
      component: TestPaper,
      meta: {
        style: false
      }
    },
    //TODO 代理记账
    {
      path: "/AgentBookKeep",
      name: "AgentBookKeep",
      component: AgentBookKeep,
      meta: {
        style: false
      }
    },
    //TODO 企业注销
    {
      path: "/EnterCancellat",
      name: "EnterCancellat",
      component: EnterCancellat,
      meta: {
        style: false
      }
    },
    //TODO 税务筹划
    {
      path: "/TaxPlan",
      name: "TaxPlan",
      component: TaxPlan,
      meta: {
        style: false
      }
    },
    //TODO 税务咨询
    {
      path: "/TaxConsultat",
      name: "TaxConsultat",
      component: TaxConsultat,
      meta: {
        style: false
      }
    },
    //TODO 海南自贸详情
    {
      path: "/hnDetail",
      name: "hnDetail",
      component: hnDetail,
      meta: {
        style: false
      }
    },
    {
      path: "/cspx",
      name: "cspx",
      component: cspx,
      meta: {
        style: false
      }
    },
    {
      path: "/dljz",
      name: "dljz",
      component: dljz,
      meta: {
        style: false
      }
    },
    {
      path: "/gczx",
      name: "gczx",
      component: gczx,
      meta: {
        style: false
      }
    },
    {
      path: "/qyzc",
      name: "qyzc",
      component: qyzc,
      meta: {
        style: false
      }
    }, 
    {
      path: "/sjfw",
      name: "sjfw",
      component: sjfw,
      meta: {
        style: false
      }
    }, 
    {
      path: "/swch",
      name: "swch",
      component: swch,
      meta: {
        style: false
      }
    }, 
    {
      path: "/swfw",
      name: "swfw",
      component: swfw,
      meta: {
        style: false
      }
    },
    {
      path: "/swzx",
      name: "swzx",
      component: swzx,
      meta: {
        style: false
      }
    },
    {
      path: "/tzzx",
      name: "tzzx",
      component: tzzx,
      meta: {
        style: false
      }
    }, 
    {
      path: "/goodsDetail",
      name: "goodsDetail",
      component: goodsDetail,
      meta: {
        style: false
      }
    }, 
    
  ]
});
